import { Component, Inject, Optional } from '@angular/core';
import { ANALYTICS_BASE_TOKEN, AnalyticsTablesBaseComponent } from '../analytics-tables-base/analytics-tables-base.component';

@Component({
  selector: 'app-analytics-report-state',
  templateUrl: './analytics-report-state.component.html',
  styleUrls: ['./analytics-report-state.component.scss'],
})
export class AnalyticsReportStateComponent {

  constructor(
    @Optional() 
    @Inject(ANALYTICS_BASE_TOKEN)
    public parent: AnalyticsTablesBaseComponent) { }
}
